import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import TwofactorContext from '@/product/context/twoFactor/twofactorContext'
import { request } from 'bwip-js'
import AuthContext from '@/product/context/auth/authContext'
import AlertContext from '@/product/context/alert/alertContext'

import EmailValidationComponent from '../../components/species/user/EmailValidationComponent'
import PhoneValidationComponent from '../../components/species/user/PhoneValidationComponent'

const TwoFactor = () => {
    const alertContext = useContext(AlertContext)
    const { setAlert } = alertContext
    const twofactorContext = useContext(TwofactorContext)
    const authContext = useContext(AuthContext)
    const {
        get2faRequest,
        request_data,
        verify2fa,
        revoke2fa,
        responseStatus: responseStatusFactor,
        clearResponse: clearResponseFactor,
    } = twofactorContext
    const { user, isAuthenticated, loadUser } = authContext

    const [changeStatus, setChangeStatus] = useState(false)
    const [updated, setUpdated] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }
    console.log(changeStatus, 'chagrr')
    const handleFunction = () => {
        get2faRequest({})
        setUpdated(true)
    }

    const validationArray = Yup.object({
        otp: Yup.string().required('Required!'),
    })

    const formik = useFormik({
        initialValues: {
            otp: '',
            secret_key: '',
            admin_id: 0,
            activate: true,
            twofa_type: null,
            phone: '',
            email: '',
            email_verified: 0,
            verified_email: '',
            phone_verified: 0,
            verified_phonenum: '',
            verify_code: '',
        },
        validateOnBlur: false,
        // validationSchema: validationArray,
        onSubmit: (values) => {
            console.log('values.phone_verified ', values.phone_verified)
            console.log('formik.values ', formik.values)
            if (values.twofa_type === 0) {
                verify2fa(values, 'verify')
            } else if (values.twofa_type === 1) {
                if (
                    values.email_verified === 1 &&
                    formik.values.verified_email === formik.values.email
                ) {
                    verify2fa(values, 'verify')
                } else {
                    setEmailVerify(true)
                }
            } else if (values.twofa_type === 2) {
                if (
                    values.phone_verified === 1 &&
                    formik.values.verified_phonenum === formik.values.phone
                ) {
                    verify2fa(values, 'verify')
                } else {
                    setPhoneVerify(true)
                }
            }
        },
    })

    useEffect(() => {
        if (formik.values.phone_verified === 1) {
            formik.submitForm()
        }
        if (formik.values.email_verified === 1) {
            formik.submitForm()
        }
    }, [formik.values.phone_verified, formik.values.email_verified])

    const options_fa = [
        {
            label: 'Property type',
            placeholder: 'Select property type',
            class: `col-12`,
            type: 'select',
            disabled: formik.values.is_default ? true : false,
            options: [
                { show: 'Third Party', value: 0 },
                { show: 'Email', value: 1 },
                { show: 'SMS', value: 2 },
            ],
            name: 'twofa_type',
            formik: formik,
        },
    ]

    const details = [
        {
            // label: ' Please enter OTP shown in the Authenticator app to verify',
            label: 'Enter code',
            placeholder: '',
            type: 'textarea',
            class: 'col-12',
            name: 'otp',
            formik: formik,
        },
    ]

    const verifyPhone = [
        {
            label: 'Verification Code',
            placeholder: 'Enter Verification Code',
            class: 'col-12',
            type: 'otpInput',
            name: 'otp',
            formik: formik,
            separator: ' ',
            placeholder: '000000',
            inputCount: 6,
        },
    ]

    const phonenumber = [
        {
            label: 'Enter phone number',
            // label: 'Please enter the phone number you want the 2FA to be enabled',
            placeholder: '',
            type: 'phone',
            class: 'col-12',
            name: 'phone',
            formik: formik,
        },
    ]

    const emailtext = [
        {
            // label: 'Please enter the email you want the 2FA to be enabled',
            label: 'Enter the email',
            placeholder: '',
            type: 'email',
            class: 'col-12',
            name: 'email',
            formik: formik,
        },
    ]

    useEffect(() => {
        if (user) {
            console.log('user email', user)
            formik.setFieldValue('admin_id', user.admin_id || '')

            formik.setFieldValue(
                'email',
                user.twofa_email || user.emp_email || ''
            )

            formik.setFieldValue(
                'phone',
                user.twofa_phone || user.emp_phone || ''
            )
        }
    }, [user])

    useEffect(() => {
        if (request_data && request_data.base64Data && updated) {
            console.log(request_data, 'dattttt')
            formik.values.secret_key = request_data.secret.base32
            setChangeStatus(true)
        }
    }, [request_data])

    useEffect(() => {
        if (responseStatusFactor && responseStatusFactor.from === 'verify') {
            setAlert(responseStatusFactor.message, responseStatusFactor.status)
            loadUser()
            setChangeStatus(false)
        } else if (
            responseStatusFactor &&
            responseStatusFactor.from === 'revoke'
        ) {
            setAlert(responseStatusFactor.message, responseStatusFactor.status)
            loadUser()
            setChangeStatus(false)
        }
        clearResponseFactor()
    }, [responseStatusFactor])

    const handleRevokeFunction = () => {
        let values = {
            secret_key: user['2fa_token'],
            admin_id: user.admin_id,
        }
        revoke2fa(values, 'revoke')
    }

    const [phoneVerify, setPhoneVerify] = useState(false)
    const [emailVerify, setEmailVerify] = useState(false)
    const [selected2FAType, setSelected2FAType] = useState(null)

    const handle2FATypeChange = (type) => {
        setSelected2FAType(type)
    }
    const [showSecretCode, setShowSecretCode] = useState(false)

    const changeEmailVerify = () => {
        setEmailVerify(!emailVerify)
    }
    const changePhoneVerify = () => {
        setPhoneVerify(!phoneVerify)
    }
    const [twoFaStatus, setTwoFaStatus] = useState(
        user && (user['2fa_enable'] || user['two_auth'])
            ? 'enabled'
            : 'disabled'
    )

    const handleUpdate = () => {
        if (twoFaStatus === 'enabled') {
            handleFunction()
        } else {
            handleRevokeFunction()
        }
    }

    const handleChange = (event) => {
        setTwoFaStatus(event.target.value)
    }

    const handleSecretCodeVisibility = () => {
        setShowSecretCode((prev) => !prev)
    }
    return (
        <Layout>
            <div className="dashboard staticPages">
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap twoFaStaticPageCnt">
                    {/* Two-factor authentication is not enabled Activate two-factor
                    authentication (2FA) for increased security and to be able
                    to access Admin portal on the go */}
                    <div className="twoFaStaticContent d-flex flex-column align-items-start">
                        <h2>Enable Two-Factor Authentication (2FA) </h2>
                        <span>
                            Two-Factor Authentication (2FA) is a security
                            feature that enhances your account&apos;s
                            protection. To access your account, you will need to
                            provide a verification code sent to your preferred
                            channel, such as a text message or email, in
                            addition to your password. This ensures that even if
                            someone knows your password, they cannot access your
                            account without the verification code.
                        </span>
                    </div>
                    {/* {user && (user['2fa_enable'] || user['two_auth']) ? (
                        <Button
                            id="taxCodelist_new"
                            variant="outlined"
                            className="btnOutlined twoFaBtnEnabled"
                            onClick={() => handleRevokeFunction()}
                        >
                            <span className="material-icons">security</span>
                            Revoke 2FA
                        </Button>
                    ) : (
                        <Button
                            id="taxCodelist_new"
                            variant="outlined"
                            className="btnOutlined twoFaBtnDisabled"
                            onClick={() => handleFunction()}
                        >
                            <span className="material-icons">security</span>
                            Activate 2FA
                        </Button>
                    )} */}
                    <form className="twoFaFieldsForm">
                        <fieldset className="d-flex flex-column align-items-start">
                            {/* <legend>Two-Factor Authentication</legend> */}
                            <label
                                className={
                                    twoFaStatus === 'enabled'
                                        ? 'twoFaLabelCls'
                                        : ''
                                }
                            >
                                <input
                                    type="radio"
                                    value="enabled"
                                    checked={twoFaStatus === 'enabled'}
                                    onChange={handleChange}
                                />
                                Every Log-in. We&apos;ll always ask for a
                                verification code
                            </label>
                            <label
                                className={
                                    twoFaStatus === 'disabled'
                                        ? 'twoFaLabelCls'
                                        : ''
                                }
                            >
                                <input
                                    type="radio"
                                    value="disabled"
                                    checked={twoFaStatus === 'disabled'}
                                    onChange={handleChange}
                                />
                                Disabled. Do not require a verification code
                            </label>
                        </fieldset>

                        <button
                            type="button"
                            className={
                                twoFaStatus === 'enabled'
                                    ? 'twoFaBtnEnabled'
                                    : 'twoFaBtnDisabled'
                            }
                            onClick={handleUpdate}
                        >
                            <span className="material-icons">security</span>
                            Update 2FA Settings
                        </button>
                    </form>
                </div>
            </div>
            <CustomDialog
                title={'Activate 2FA'}
                open={changeStatus}
                function={changeChangeStatus}
                className="activateTwoFaDialog"
            >
                {/* <div className="row"> {mapData(options_fa)} </div> */}
                {formik.values.twofa_type === null && (
                    <>
                        <div className="cstmButtonGroup d-flex flex-column align-items-start">
                            {options_fa[0].options.map((option, index) => (
                                <Button
                                    key={option.value}
                                    className={`cstmBtn ${
                                        formik.values.twofa_type ===
                                        option.value
                                            ? 'active'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        formik.setFieldValue(
                                            'twofa_type',
                                            option.value
                                        )
                                    }
                                >
                                    <div className="activateFactorCnt d-flex">
                                        <span className="material-icons-outlined">
                                            {option.value === 0
                                                ? 'qr_code_scanner'
                                                : option.value === 1
                                                  ? 'mail'
                                                  : 'sms'}
                                        </span>
                                        <div>
                                            <span> {option.show} </span>
                                            <span>
                                                {option.value === 0 &&
                                                    `Scan the provided QR code using an
                                            authentication app (Google
                                            Authenticator, Microsoft
                                            Authenticator, Authy, etc.) to set
                                            up 2FA. Once configured, your app
                                            will generate time-sensitive codes
                                            that must be entered during login
                                            for added security.`}
                                                {option.value === 1 &&
                                                    `Click to receive a two-factor
                                            authentication (2FA) code via email.
                                            This method adds an extra layer of
                                            security by sending a verification
                                            code directly to your registered
                                            email address, which you will need
                                            to enter to complete the login
                                            process.`}
                                                {option.value === 2 &&
                                                    ` Click to receive a 2FA code via SMS.
                                            A verification code will be sent to
                                            your registered mobile number, which
                                            must be entered to successfully log
                                            in. Ensure that your mobile number
                                            is up to date to avoid any issues.`}
                                            </span>
                                        </div>
                                    </div>
                                </Button>
                            ))}
                        </div>
                        <div className="actionWrapper">
                            <Button
                                id="taxCodeList_cancel"
                                className="twoFaCancelBtn"
                                onClick={() => {
                                    setChangeStatus(false)
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </>
                )}

                {/* {formik.values.twofa_type === 0 ? ( */}
                {formik.values.twofa_type === 0 ? (
                    <div className="cstmThirdPartyCnt">
                        <h5>Third party Authentication</h5>
                        <div className="pclImg">
                            <img src={request_data.base64Data} alt={''} />
                        </div>
                        <div className="cstmThirdStepCnt">
                            <div className="cstmThirdSteps one">
                                <span className="material-icons-outlined">
                                    screenshot
                                </span>
                                <span>Open your authenticator app</span>
                            </div>
                            <div className="cstmThirdSteps two">
                                <span className="material-icons-outlined">
                                    qr_code_scanner
                                </span>
                                <div>
                                    <span>
                                        Scan this QR code with your
                                        authentication application...
                                    </span>
                                    <Button
                                        onClick={handleSecretCodeVisibility}
                                        className="cstmSecretCodeBtn"
                                    >
                                        {showSecretCode
                                            ? 'Hide Secret'
                                            : 'Show Secret'}
                                    </Button>
                                    {showSecretCode && (
                                        <div className="cstmSecretCodeCnt">
                                            {request_data.secret.base32}
                                            <span className="material-icons">
                                                content_copy
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="cstmThirdSteps three">
                                <span className="material-icons-outlined panTool">
                                    pan_tool_alt
                                </span>
                                <span>
                                    Please enter OTP shown in the Authenticator
                                    app to verify
                                </span>
                            </div>
                        </div>

                        <div className="row cstmRowInput">
                            {Object.values(mapData(details))}
                        </div>

                        <div className="actionWrapper">
                            <Button
                                id="taxCodeList_cancel"
                                onClick={() => {
                                    formik.setFieldValue('twofa_type', null)
                                }}
                            >
                                Back
                            </Button>
                            <PrimaryButton
                                id="twofactor_verify"
                                type="Activate"
                                label="Verify"
                                onClick={() => formik.handleSubmit()}
                            />
                        </div>
                    </div>
                ) : formik.values.twofa_type === 1 ? (
                    <>
                        <div className="cstmConfirmCnt cstmThirdStepCnt">
                            <h5>Email Authentication</h5>
                            <span>
                                Confirm the email to which the OTP will be sent
                                everytime you try to login.
                            </span>
                            <div className="row">{mapData(emailtext)}</div>
                        </div>
                        <div className="actionWrapper">
                            <Button
                                id="taxCodeList_cancel"
                                onClick={() => {
                                    formik.setFieldValue('twofa_type', null)
                                }}
                            >
                                Back
                            </Button>
                            <PrimaryButton
                                id="twofactor_verify"
                                type="submit"
                                // label={
                                //     formik.values.email_verified === 1 &&
                                //     formik.values.verified_email ===
                                //         formik.values.email
                                //         ? 'Activate'
                                //         : 'Verify'
                                // }
                                label={'Verify'}
                                onClick={() => formik.handleSubmit()}
                            />
                        </div>
                    </>
                ) : formik.values.twofa_type === 2 ? (
                    <>
                        <div className="cstmConfirmCnt">
                            <h5>SMS Authentication</h5>
                            <span>
                                Confirm the phone number to which the OTP will
                                be sent every time you try to log in.
                            </span>
                            <div className="row">{mapData(phonenumber)}</div>
                        </div>

                        <div className="actionWrapper">
                            <Button
                                id="taxCodeList_cancel"
                                onClick={() => {
                                    formik.setFieldValue('twofa_type', null)
                                }}
                            >
                                Back
                            </Button>
                            <PrimaryButton
                                id="twofactor_verify"
                                type="submit"
                                // label={
                                //     formik.values.phone_verified === 1 &&
                                //     formik.values.verified_phonenum ===
                                //         formik.values.phone
                                //         ? 'Activate'
                                //         : 'Verify'
                                // }
                                label={'Verify'}
                                onClick={() => formik.handleSubmit()}
                            />
                        </div>
                    </>
                ) : null}
            </CustomDialog>

            <PhoneValidationComponent
                phoneVerify={phoneVerify}
                formik={formik}
                setPhoneVerify={setPhoneVerify}
                changePhoneVerify={changePhoneVerify}
            />
            <EmailValidationComponent
                emailVerify={emailVerify}
                formik={formik}
                setEmailVerify={setEmailVerify}
                changeEmailVerify={changeEmailVerify}
                verifyStatusChange={false}
                registerUniqueEmail={false}
                noToken={true}
            />
        </Layout>
    )
}
export default TwoFactor
